import { Navigate } from "react-router-dom";

export default function RutaProtegida({ children }) {
  const token = localStorage.getItem("access"); // O el nombre que uses
  
  if (!token) {
    return <Navigate to="/" replace />; // Redirige al login si no hay token
  }
  
  return children;
}
